import React from 'react';
import Navbar from '../components/Navbar';
import '../App.css';
import './Compliance.css';

const Compliance = () => {
  return (
    <div className="App">
      <Navbar />
      <main className="compliance-container">
        <section className="compliance-hero">
          <h1>Compliance Statement</h1>
          <p className="compliance-subtitle">Aspen Quick Care</p>
        </section>
        
        <section className="compliance-content">
          <div className="compliance-section">
            <p>
              Aspen Quick Care is committed to following all federal, state, and local laws. 
              To support this, we have a Compliance Program that helps ensure our team members 
              and partners understand their responsibilities and maintain high ethical and 
              legal standards.
            </p>
            
            <p>
              If you are a team member, customer, or partner and notice anything that may be 
              a compliance concern, we encourage you to report it — either with your name or 
              anonymously. All reports are reviewed by our compliance team, and we do not 
              tolerate retaliation of any kind.
            </p>
            
            <div className="report-section">
              <h2>To report a potential compliance issue, please contact:</h2>
              <p className="contact-email">
                <a href="mailto:bettercare@aspenquickcare.com" className="email-link">bettercare@aspenquickcare.com</a>
              </p>
              <p className="confidentiality-note">
                All reports are kept confidential to the fullest extent possible.
              </p>
            </div>
          </div>
        </section>
      </main>
    </div>
  );
};

export default Compliance;
